<template>
  <div class="container">
    <div class="row">
      <input v-model="listName"
             type="text"
             placeholder="Name of the shopping list"
             class="column editable-name"
             id="list-name">
      <a href="#" @click="deleteList" class="button column-25">Delete List</a>
    </div>

    <div class="row" id="item-list-row">
      <ItemList :items="data.items"
                :list-id="data.id"
                :is-loading="isLoading"
                @loading="isLoading = true"
                @refresh-list=refreshList />
    </div>
  </div>
</template>

<script>
import ItemList from './ItemList.vue'

export default {
  name: 'ListPage',
  data: function() {
    return {
      isLoading: true,
      listName: "",
      data: {}
    }
  },
  props: {
    listId: {
      type: String,
      // If not defined, go to error page
      default: () => { this.$router.push('/404') }
    }
  },
  watch: {
    //FIXME: don't update on each keystroke, wait for end of input
    listName: function() {
      // No need to update if the name is already good
      if (this.listName === this.data.name) {
        return true
      }

      let form = new FormData();
      form.set('data', `{"name": "${this.listName}"}`)

      this.$http.post(
        `https://api.shoplist.peuvrel.net/list/${this.listId}`,
        form
      ).then((response) => {
        this.data = JSON.parse(response.data.data)
      });
    }
  },
  components: {
    ItemList
  },
  methods: {
    deleteList() {
      this.$http.delete(
        `https://api.shoplist.peuvrel.net/list/${this.listId}`
      ).then(() => {
        this.$router.push('/')
      });
    },
    refreshList() {
      this.isLoading = true
      this.$http.get(
        `https://api.shoplist.peuvrel.net/list/${this.listId}`
      ).then((response) => {
        this.data = JSON.parse(response.data.data)
        this.isLoading = false
        if (this.data.name)
          this.listName = this.data.name
      }).catch(() => {
          this.$router.push('/404')
      });
    }
  },
  mounted: function() {
    this.refreshList();
  },
}
</script>

<style>

input.editable-name {
  margin: 10px;
  border: none;
  border-bottom: 1px solid #ccc;
}

#list-name {
  font-size: 32px;
}

#item-list-row {
  margin-top: 25px;
}
</style>
